import { useEffect, useRef } from "react";

export function useScrollToTop(query: string) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, left: 0 });
  }, [query]);

  return scrollRef;
}
